import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotComics() {
  const hot = [...comics].filter(c => c.isHot).sort((a, b) => b.views - a.views).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门排行
            </h2>
            <p className="text-sm text-foreground-500 mt-2">本周最受读者欢迎的韩漫作品</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop="">
          {hot.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex gap-4 p-4 rounded-lg bg-background-100 hover:bg-secondary-50 transition-colors cursor-pointer"
            >
              <div className="relative flex-shrink-0">
                <div className="w-16 h-20 md:w-20 md:h-28 rounded-lg overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 韩国漫画无删减下拉式`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="absolute -top-2 -left-2 w-6 h-6 rounded-full bg-primary-500 text-white text-xs font-bold flex items-center justify-center">
                  {index + 1}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{comic.description}</p>
                <div className="flex items-center gap-3 mt-2 flex-wrap">
                  <span className="text-xs text-foreground-500">{comic.author}</span>
                  <span className="text-xs text-accent-600 font-medium">★ {comic.rating}</span>
                  <span className="text-xs text-foreground-400">{(comic.views / 10000).toFixed(0)}万阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}